<template>
  <!-- Tipo y fecha de pago, y la seccion Periodo (la quincena solo para el tipo quincenal) -->
  <div>
    <div class="pf-grid pf-grid--2">
      <BaseCombobox label="Tipo*" name="type" v-model="type" :items="types" item-text="name" item-value="id"
        :rules="'required|combobox_required'" :validationErrors="errors" />
      <BaseDatePicker label="Fecha de pago*" name="payment_date" v-model="value.payment_date" :rules="'required'"
        :validationErrors="errors" />
    </div>
    <div class="pf-section-title">Período</div>
    <div class="pf-grid" :class="isBiweekly ? 'pf-grid--3' : 'pf-grid--2'">
      <BaseCombobox v-if="isBiweekly" label="Quincena*" name="period_number" v-model="period_number" :items="biweekly_numbers"
        item-text="name" item-value="id" :rules="'required|combobox_required'" :validationErrors="errors" />
      <BaseCombobox label="Mes*" name="period_month" v-model="period_month" :items="months" item-text="name" item-value="id"
        :rules="'required|combobox_required'" :validationErrors="errors" />
      <BaseCombobox label="Año*" name="period_year" v-model="value.period_year" :items="years" :rules="'required'"
        :validationErrors="errors" />
    </div>
  </div>
</template>

<script>
import BaseCombobox from "@/components/BaseCombobox.vue";
import BaseDatePicker from "@/components/BaseDatePicker.vue";
import { PAYSLIP_TYPES, PAYSLIP_TYPE_BIWEEKLY, MONTHS, BIWEEKLY_NUMBERS, yearOptions } from "@/constants/payslips";

// El combobox trabaja con el objeto elegido; el modelo (y el backend) guardan el id
function byId(items, id) {
  return items.find((item) => item.id == id) || null;
}

// Campos comunes de la carga masiva e individual. Comparte el validador del modal que lo contiene.
export default {
  components: { BaseCombobox, BaseDatePicker },
  inject: ["$validator"],
  props: {
    value: Object,
  },
  data() {
    return {
      types: PAYSLIP_TYPES,
      months: MONTHS,
      biweekly_numbers: BIWEEKLY_NUMBERS,
      years: yearOptions(),
    };
  },
  computed: {
    isBiweekly() {
      return this.value.type == PAYSLIP_TYPE_BIWEEKLY;
    },
    type: {
      get() {
        return byId(this.types, this.value.type);
      },
      set(item) {
        this.value.type = item && item.id ? item.id : null;
      },
    },
    period_month: {
      get() {
        return byId(this.months, this.value.period_month);
      },
      set(item) {
        this.value.period_month = item && item.id ? item.id : null;
      },
    },
    period_number: {
      get() {
        return byId(this.biweekly_numbers, this.value.period_number);
      },
      set(item) {
        this.value.period_number = item && item.id ? item.id : null;
      },
    },
  },
};
</script>

<style scoped>
.pf-grid {
  display: grid;
  column-gap: 16px;
}
.pf-grid--2 {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}
.pf-grid--3 {
  grid-template-columns: repeat(3, minmax(0, 1fr));
}
.pf-section-title {
  margin: 4px 0 8px;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: #4d6269;
  text-align: left;
}
@media (max-width: 600px) {
  .pf-grid--3 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}
</style>
